{
  class GrandchildNavExpand extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.main-nav__grandchild');
      this.button = this.querySelector('.grandchild-nav__toggle');
      this.isExpanded = false;
      this.collapsedHeight = 0;
      this.initialized = false;
    }

    connectedCallback() {
      if (!this.list || !this.button) return;

      this.button.addEventListener('click', this.toggleExpand.bind(this));
      
      // Wait for the element to become visible before measuring
      this.observeVisibility();
    }

    observeVisibility() {
      // Use IntersectionObserver to detect when element becomes visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.initialized) {
            // Wait one more frame to ensure layout is complete
            requestAnimationFrame(() => {
              this.init();
              observer.disconnect();
            });
          }
        });
      }, { threshold: 0.01 });

      observer.observe(this);
    }

    init() {
      if (this.initialized) return;
      
      const firstAnchor = this.list.querySelector('.main-nav__item');
      const anchorStyles = firstAnchor ? window.getComputedStyle(firstAnchor) : window.getComputedStyle(this.list);

      const headerBottomMargin = 8;
      const lineHeight = parseFloat(anchorStyles.lineHeight) || 20;
      const numLines = 3;
      this.collapsedHeight = Math.ceil(headerBottomMargin + lineHeight * numLines);

      const fullHeight = this.list.scrollHeight;
      if (fullHeight > this.collapsedHeight + 12) {
        this.list.style.maxHeight = `${this.collapsedHeight}px`;
        this.list.style.overflow = 'hidden';
        this.button.style.display = 'block';
      }
      
      this.initialized = true;
    }

    toggleExpand() {
      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        this.list.style.maxHeight = `${this.list.scrollHeight}px`;
        this.button.textContent = this.button.dataset.textLess || 'Show less';
        this.button.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          this.list.style.maxHeight = 'none';
        }, 300);
      } else {
        this.list.style.maxHeight = `${this.list.scrollHeight}px`;
        this.list.offsetHeight;
        this.list.style.maxHeight = `${this.collapsedHeight}px`;
        this.button.textContent = this.button.dataset.textMore || 'Show more';
        this.button.setAttribute('aria-expanded', 'false');
      }
    }
  }

  customElements.define('grandchild-nav-expand', GrandchildNavExpand);
}


